enum LOG_TYPE {
  WIDGET_PROPERTY_VALIDATION_ERROR,
  WIDGET_UPDATE,
  ACTION_EXECUTION_ERROR,
  ACTION_EXECUTION_SUCCESS,
  ENTITY_DELETED,
  EVAL_ERROR,
  TRIGGER_EVAL_ERROR,
  EVAL_WARNING,
  ACTION_UPDATE,
  JS_ACTION_UPDATE,
  JS_PARSE_ERROR,
  JS_PARSE_SUCCESS,
  JS_EXECUTION_ERROR,
  CYCLIC_DEPENDENCY_ERROR,
  LINT_ERROR,
  MISSING_MODULE,
  INVALID_GIT_DEPLOY_KEY,
}

export default LOG_TYPE;
